module.exports = __webpack_public_path__ + "img/vue.b641c6f1.svg";